var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"temporary":"","fixed":"","width":"600"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('filters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }